import { showToast } from "./show.toast";

export const handleCatchError = (error, setFieldError, customHandle) => {
  if (error && error.response?.status === 422) {
    const errors = error.response.data.errors;
    if (errors && Object.keys(errors).length > 0) {
      Object.keys(errors).forEach((item) => {
        const message = errors[item][0];

        if (customHandle && typeof customHandle === "function") {
          customHandle();
          return;
        }

        if (setFieldError && typeof setFieldError === "function") {
          setFieldError(item, message);
        } else {
          showToast("Error!", message, "error");
        }
      });
    }
  }
};
